import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import {SERVER_API_URL} from '../../app.constants';
import {createRequestOption} from '../../shared/util/request-util';
import {ISupplier} from "../../shared/model/supplier.model";


type EntityResponseType = HttpResponse<ISupplier>;
type EntityArrayResponseType = HttpResponse<ISupplier[]>;

@Injectable({providedIn: 'root'})
export class SupplierService {
  public resourceUrl = SERVER_API_URL + 'api/suppliers';

  constructor(protected http: HttpClient) {
  }

  create(supplier: ISupplier): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(supplier);
    return this.http
      .post<ISupplier>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  update(supplier: ISupplier): Observable<EntityResponseType> {
    const copy = this.convertDateFromClient(supplier);
    return this.http
      .put<ISupplier>(this.resourceUrl, copy, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<ISupplier>(`${this.resourceUrl}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http
      .get<ISupplier[]>(this.resourceUrl, {params: options, observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  findMySupplierCount(id: number): Observable<HttpResponse<any>> {
    return this.http
      .get<any>(`${this.resourceUrl + '-self-count'}/${id}`, {observe: 'response'});
  }

  findMySupplier(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<ISupplier[]>(`${this.resourceUrl + '-self'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  findSupplierTransaction(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<ISupplier[]>(`${this.resourceUrl + '-transaction'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }
  findWithCustomerId(id: number): Observable<EntityArrayResponseType> {
    // const options = createRequestOption(req);
    return this.http
      .get<ISupplier[]>(`${this.resourceUrl + '-customer'}/${id}`, {observe: 'response'})
      .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  }

  delete(id: number): Observable<HttpResponse<any>> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`, {observe: 'response'});
  }

  protected convertDateFromClient(supplier: ISupplier): ISupplier {
    const copy: ISupplier = Object.assign({}, supplier, {
    });
    return copy;
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      // res.body.expiratioDate = res.body.expiratioDate != null ? moment(res.body.expiratioDate) : null;
    }
    return res;
  }

  protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body) {
      res.body.forEach((supplier: ISupplier) => {
      });
    }
    return res;
  }
}
